// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import constants from './constants/internationalization.services.constants';
// Types
import { LanguageServiceResponseType } from '../types/language-service-response.type';

const fetchLanguagesConfigurationService = async (
  language: string
): Promise<[LanguageServiceResponseType, Response]> =>
  apiUtils.get({
    ...constants.FETCH_TRANSLATIONS_SERVICE,
    language,
  });

const fetchLanguageService = async (
  url: string
): Promise<[LanguageServiceResponseType, Response]> =>
  apiUtils.get({
    ...constants.STATIC_CALL_PARAMS,
    absoluteUrl: url,
  });

export { fetchLanguagesConfigurationService, fetchLanguageService };
